import React from 'react';
import { PageHeader } from '../../components/PageHeader';
import { SettingsGroup, SettingsToggleRow } from '../../components/SettingsList';
import { Card, SectionTitle } from '../../components/ui/Card';
import { accessibilityPrefs } from '../../data/settings';
import { useLocale } from '../../contexts/LocaleContext';
import { useSettings } from '../../contexts/SettingsContext';
export function AccessibilitySettings() {
  const {
    t,
    tl
  } = useLocale();
  const settings = useSettings();
  return <div className="px-2 pb-2" data-id="element-3287" data-mp="1p8b2ymj2tcme">
      <PageHeader title={t('settings.accessibility')} subtitle={t('a11y.subtitle')} showBack data-id="element-3288" data-mp="1p7jhw5n3uxad" />

      <SettingsGroup data-id="element-3289" data-mp="1u1nqetc0rddk">
        {accessibilityPrefs.map(pref => <SettingsToggleRow key={pref.id} label={tl(pref.label)} hint={tl(pref.hint)} checked={settings.accessibility[pref.id]} onChange={() => settings.toggleAccessibility(pref.id)} data-id="element-3290" data-mp="1yxclokh0a842" />)}
      </SettingsGroup>

      <section className="mt-3" data-id="element-3291" data-mp="gn8mqcbfwpfq">
        <SectionTitle data-id="element-3292" data-mp="gk2yt0ejrtll">{t('a11y.reader')}</SectionTitle>
        <Card className="p-2" data-id="element-3293" data-mp="ckcar4genrkr">
          <p className="text-[12.5px] leading-relaxed text-deep" data-id="element-3294" data-mp="cj10qmwd9nl7">
            {t('a11y.readerBody')}
          </p>
          <ul className="mt-2 space-y-1" data-id="element-3295" data-mp="7nlmvuyczros">
            {['a11y.point1', 'a11y.point2', 'a11y.point3'].map(key => <li key={key} className="flex items-start gap-2 text-[12px] leading-snug text-muted" data-id="element-3296" data-mp="10a6mtjswhc3y">
                <span className="mt-[6px] h-[5px] w-[5px] shrink-0 rounded-pill bg-gold" aria-hidden="true" data-id="element-3297" data-mp="vcejzuqpw5kz" />
                {t(key)}
              </li>)}
          </ul>
        </Card>
      </section>

      <p className="mt-2 px-1 text-[11px] leading-snug text-muted" data-id="element-3298" data-mp="1j0edv3jbsc3s">
        {t('a11y.note')}
      </p>
    </div>;
}